import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type { AxiosRequestConfig, AxiosError, AxiosInstance } from "axios";

export const axiosBaseQuery =
  (
    axiosInstance: AxiosInstance
  ): BaseQueryFn<
    {
      url: string;
      method?: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      headers?: AxiosRequestConfig["headers"];
      signal?: AxiosRequestConfig["signal"];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers, signal }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data,
        params,
        headers,
        signal,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
